<template>
<div class="chapter">
<div class="inner_page">
<div class="epigraphPage">
<a id="title40"></a>
<div class="verse"><span>In wartime, the truth is so precious that it must be protected by a bodyguard of lies.</span></div>
<div class="source"><span>—Winston Churchill</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="verse"><span>They change their clime, but not their minds … who rush across the sea.</span></div>
<div class="source"><span>—Horace</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781466824409_epi01.vue?11dc1e62